import React, { useEffect, useState } from 'react'
import { Typography, makeStyles, Grid, Button } from '@material-ui/core'
import { AgentInfo, ConsumerInfo, RequestInfo } from 'src/app/components/confirmation-info'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, submitCcpaThunk } from 'src/lib/store'
import { ConfirmationModal } from 'src/app/components/ConfirmationModal'

export const ConfirmationPage: React.FC = () => {
  const classes = useStyles()
  const history = useHistory()
  const payloadState = useSelector((state: RootState) => state.payload.data)
  const dispatch = useDispatch()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(false)

  useEffect(() => {
    if (payloadState.relationshipType === '') history.replace('/')
  }, [history, payloadState.relationshipType])

  const handleSubmit = async () => {
    setDialogOpen(true)
    setButtonDisabled(true)
    await dispatch(submitCcpaThunk(payloadState))
  }

  return (
    <>
      <ConfirmationModal dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
      <Typography variant="body1" className={classes.title}>
        Please review {payloadState.onBehalf === 'Yes' ? 'agent, consumer, and request information below.' : 'your consumer, and request information below.'}
      </Typography>
      <Typography variant="h5" className={classes.title}>
        Does everything look okay?
      </Typography>

      {payloadState.onBehalf === 'Yes' && <AgentInfo />}
      <ConsumerInfo />
      <RequestInfo />

      <Grid container className={classes.buttonContainer}>
        <Grid item xs={6}>
          <Button className={classes.button} color="primary" variant="contained" onClick={() => history.goBack()}>
            Back
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button className={classes.button} color="secondary" variant="contained" id="submit-btn" disabled={buttonDisabled} onClick={handleSubmit}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

const useStyles = makeStyles({
  title: { textAlign: 'center', marginBottom: 10 },
  subTitle: { paddingLeft: 30 },
  buttonContainer: { marginTop: 75 },
  button: { margin: '25px 0 25px 0', width: '90%', fontWeight: 'bold', color: '#ffffff' }
})
